import { useContext } from "react";
import styles from "./Latlng.module.css";
import SiteContext from "../../context/SiteContext";

const LatLng = () => {
    const { currLatLng } = useContext(SiteContext);
    return (
        <div className={styles.latlng}>
            {currLatLng.lat}, {currLatLng.lng}
        </div>
    );
};

export default LatLng;
